import { useDialogFormStore } from '@/components/dialog/form.store';
import { Button } from '@/design-system/button';
import { useDynamicLocale } from '@/hoslog-intl';
import { Copy, QrCode } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';
import { toast } from 'sonner';

export function ReferralDetailHeader({
  name,
  referralUrl,
  qrUrl,
}: {
  name: string;
  referralUrl: string;
  qrUrl: string;
}) {
  const { onOpen } = useDialogFormStore();
  const { t } = useDynamicLocale();

  const copyReferralUrl = async () => {
    try {
      await navigator.clipboard.writeText(referralUrl);
      toast.success(t('dashboard.referralReports.referralLink.successMessage'));
    } catch {
      toast.error(t('dashboard.referralReports.referralLink.unsuccessMessage'));
    }
  };

  return (
    <div className="rounded-[8px] bg-card px-4 py-3">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="min-w-0">
          <h2 className="truncate text-xs font-bold text-primary">{name}</h2>
          <p className="mt-1 truncate text-xs font-medium text-foreground-subtle">{referralUrl}</p>
        </div>
        <div className="flex items-center gap-2">
          <Button
            type="button"
            variant="outline"
            size="icon"
            aria-label="Copy referral link"
            onClick={() => void copyReferralUrl()}
          >
            <Copy className="text-info" />
          </Button>
          <Button
            type="button"
            variant="outline"
            size="icon"
            aria-label="Show referral QR code"
            onClick={() => {
              onOpen({
                title: '',
                modalTitle: '',
                okText: ' ',
                cancelText: '',
                size: 'qr',
                image: true,
                component: (
                  <div className="flex items-center justify-center py-4">
                    <QRCodeSVG value={qrUrl} size={280} marginSize={4} title={`QR code for ${name}`} />
                  </div>
                ),
              });
            }}
          >
            <QrCode className="text-warning" />
          </Button>
        </div>
      </div>
    </div>
  );
}
